import Vue from "vue";

class ConfigHandler {
    constructor() {
        this.selected = null;
    }

    selectAircraft(name){
        this.selected = name.toUpperCase();
        this.config = require(`./${this.selected}/cockpit.json`);
        this.procedures = require(`./${this.selected}/procedures.json`);
        this.poi = require(`./${this.selected}/poi.json`);
        return this;
    }

    getPOI(name){
        if(!this.poi[name]){
            throw new Error('POI "'+name+'" not found! Available: ' + Object.keys(this.poi).join(','))
        }
        return this.poi[name];
    }

    getConfig() {
        return this.config;
    }

    getAsset(assetName){
        if(!this.config.assets[assetName]) return undefined;
        Vue.$log.debug('get asset', assetName, this.config.assets[assetName], this.selected)
        return '/' + this.config.assets[assetName];
    }

    getButton(name){
        if(!this.config.assets.btn_dir){
            throw new Error('Button Directory not defined but called')
        }

        return "/" + this.config.assets.btn_dir + name + ".png";
    }

    find(aircraft){
        return aircrafts.filter(handler => handler.selected === aircraft)[0];
    }

    getMeshPath(filename) {
        if(this.config.mesh && this.config.mesh[filename])
            return this.preprendSlash(this.config.mesh[filename]);
        return `/airplanes/${this.selected}/mesh/${filename}.glb`;
    }

    preprendSlash(path){
        return '/' + path.replace(/^\//, '')
    }
}

export const settings = {
    START_SLIDER_FOV: 250,
    START_SLIDER_POI: 100,
    _FOV_START: 70,
    _FOV_MIN: 30,
    _FOV_MAX: 100,
    _SLIDER_RES: 500,
    DELAY_LOADING_SCREEN_COCKPIT: 1000,
    TWEEN_MAX_TIME: 1500,
    TWEEN_MIN_TIME: 300,
    DEFAULT_LOOKAT_POS: [5000, -1500, 0],
    MARKER_PADDING_LEFT: 25,
    MARKER_PADDING_TOP: 8,
    DEBUGVISIBLE: false,
    ANIMATION_TIME_THUMB_UP_DOWN: 700,
    MARKER_LINE_COLOR: '#ffffff',
    SECONDARY_COLOR: '#f9ba00',
    HIGHLIGHT_COLOR: '#f9ba00',
    INFOPOINT_SCALE: 300,
    INFOPOINT_MAX_TRANSPARENCY: 0.6,
    HIDEINFOPOINTAFTERHOVER: 500
};

export const LufthansaColors = {
    yellow: '#ffad00',
    blue_deep: '#05164d',
    text_blue: '#05164D',
    text_grey: '#666666',
    blue_breeze1: '#849AC2',
    blue_breeze2: '#6E8BB7',
    white: '#ffffff',
    grey1: '#f5f5f5',
    grey2: '#ebebeb',
    interaction: '#52627C',
    interaction_hover: '#414E63',
    button_primary: '#FFAD00',
    button_primary_hover: '#FFBD32',
    button_secondary: '#05164D',
    sky_blue_1:'#3588C9',
    sky_blue_2:'#75BCE9',
    sky_blue_3:'#CFEBFC',
    pidgeon_blue_1:'#8BB4C9',
    pidgeon_blue_2:'#BBD9E5',
    pidgeon_blue_3:'#DDEBF1',
}

export const aircrafts = ['A320', 'B787']
    .map(aircraft => new ConfigHandler().selectAircraft(aircraft))

export const aircraftConfig = new ConfigHandler();